import {useEffect, useRef} from "react";
import {IRouteInfoMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/types";
import {StateMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/route/mutateRoute/types";
import {
    useGetStateMutateRouteSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/route/mutateRoute/hooks/useStateMutateRouteSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";
import moment from "moment/moment";
import {
    DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE
} from "@containers/singleVoyage/mutateVoyage/route/constants/dateFormat";


export function useStateMutateRouteWithHotUpdateSingleVoyage({initial}: {
    initial?: IRouteInfoMutateSingleVoyage,
}): StateMutateSingleVoyage {

    const stateMutateSingleVoyage = useGetStateMutateRouteSingleVoyage({initial})

    const {setRouteInfo, accountId, voyageId} = useRootContextMutateSingleVoyage()
    const prevAccountIdRef = useRef<string>(accountId)

    useEffect(() => {
        if (prevAccountIdRef.current === accountId) {
            return
        }
        prevAccountIdRef.current = accountId
        if (voyageId) {
            return
        }
        stateMutateSingleVoyage.onChangeDeviceId('')
        stateMutateSingleVoyage.onChangeDriverId('')
    }, [accountId])

    const handleChangeStatus = (status: VoyageStatusSingleVoyage) => {
        stateMutateSingleVoyage.onChangeStatus(status)
        setRouteInfo((prev) => {
            return {
                ...prev,
                status,
            }
        })
    }

    const handleChangeTitle = (title: string) => {
        stateMutateSingleVoyage.onChangeTitle(title)
        setRouteInfo((prev) => {
            return {
                ...prev,
                title
            }
        })
    }
    const handleChangeDriverId = (driverId: string) => {
        stateMutateSingleVoyage.onChangeDriverId(driverId)
        setRouteInfo((prev) => {
            return {
                ...prev,
                driverId: driverId ? Number(driverId) : null,
            }
        })
    }
    const handleChangeDeviceId = (deviceId: string) => {
        stateMutateSingleVoyage.onChangeDeviceId(deviceId || '')
        setRouteInfo((prev) => {
            return {
                ...prev,
                deviceId: deviceId ? Number(deviceId) : 0,
            }
        })
    }
    const handleChangePlannedStart = (plannedStart: string) => {
        stateMutateSingleVoyage.onChangePlannedStart(plannedStart)
        setRouteInfo((prev) => {
            return {
                ...prev,
                plannedStart: moment(plannedStart, DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE).toISOString(),
            }
        })
    }
    const handleChangePlannedEnd = (plannedEnd: string) => {
        stateMutateSingleVoyage.onChangePlannedEnd(plannedEnd)
        setRouteInfo((prev) => {
            return {
                ...prev,
                plannedEnd: moment(plannedEnd, DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE).toISOString(),
            }
        })
    }

    const handleChangeOnRouteControl = (onRouteControl: boolean) => {
        stateMutateSingleVoyage.onChangeOnRouteControl(onRouteControl)
        setRouteInfo((prev) => {
            return {
                ...prev,
                config: {
                    ...prev?.config,
                    onRouteControl,
                },
            }
        })
    }

    const handleChangeWaypointOrderControl = (waypointOrderControl: boolean) => {
        stateMutateSingleVoyage.onChangeWaypointOrderControl(waypointOrderControl)
        setRouteInfo((prev) => {
            return {
                ...prev,
                config: {
                    ...prev?.config,
                    waypointOrderControl,
                },
            }
        })
    }

    const handleChangeNotification = (notification: boolean) => {
        stateMutateSingleVoyage.onChangeNotification(notification)
        setRouteInfo((prev) => {
            return {
                ...prev,
                config: {
                    ...prev?.config,
                    notification,
                },
            }
        })
    }
    return {
        status: stateMutateSingleVoyage.status,
        onChangeStatus: handleChangeStatus,
        title: stateMutateSingleVoyage.title,
        onChangeTitle: handleChangeTitle,
        driverId: stateMutateSingleVoyage.driverId,
        onChangeDriverId: handleChangeDriverId,
        deviceId: stateMutateSingleVoyage.deviceId,
        onChangeDeviceId: handleChangeDeviceId,
        plannedStart: stateMutateSingleVoyage.plannedStart,
        onChangePlannedStart: handleChangePlannedStart,
        plannedEnd: stateMutateSingleVoyage.plannedEnd,
        onChangePlannedEnd: handleChangePlannedEnd,
        onRouteControl: stateMutateSingleVoyage.onRouteControl,
        onChangeOnRouteControl: handleChangeOnRouteControl,
        waypointOrderControl: stateMutateSingleVoyage.waypointOrderControl,
        onChangeWaypointOrderControl: handleChangeWaypointOrderControl,
        notification: stateMutateSingleVoyage.notification,
        onChangeNotification: handleChangeNotification,
    }
}